import { render, staticRenderFns } from "./mention-icon.vue?vue&type=template&id=0cd1d068"
import script from "./mention-icon.vue?vue&type=script&lang=js"
export * from "./mention-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd1d068')) {
      api.createRecord('0cd1d068', component.options)
    } else {
      api.reload('0cd1d068', component.options)
    }
    module.hot.accept("./mention-icon.vue?vue&type=template&id=0cd1d068", function () {
      api.rerender('0cd1d068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/mention-icon.vue"
export default component.exports